import type { PadelGameListItem, PadelSessionListItem } from '@/services/padelService';

export interface FlatPadelGame {
  game: PadelGameListItem;
  sessionSlug: string;
  sessionType: string;
  rotationFormat?: string;
}

export function flattenPadelGames(sessions: PadelSessionListItem[]): FlatPadelGame[] {
  const result: FlatPadelGame[] = [];

  for (const session of sessions) {
    const games = [...(session.games ?? [])].sort((a, b) => {
      const roundA = a.roundNumber ?? a.id;
      const roundB = b.roundNumber ?? b.id;
      if (roundA !== roundB) return roundA - roundB;
      const courtA = a.courtNumber ?? 0;
      const courtB = b.courtNumber ?? 0;
      if (courtA !== courtB) return courtA - courtB;
      return a.id - b.id;
    });

    for (const game of games) {
      result.push({
        game: {
          ...game,
          sessionSlug: game.sessionSlug || session.slug,
        },
        sessionSlug: session.slug,
        sessionType: session.sessionType,
        rotationFormat: session.rotationFormat,
      });
    }
  }

  return result;
}

export function roundGames(round: {
  games?: PadelGameListItem[];
  game?: PadelGameListItem;
}): PadelGameListItem[] {
  if (round.games && round.games.length > 0) return round.games;
  return round.game ? [round.game] : [];
}

